export type BreadcrumbItem = {
  label: string;
  to?: string;
};

export const PRODUCT_BREADCRUMB: readonly BreadcrumbItem[] = [
  { label: 'Home', to: '/' },
  { label: 'Product', to: '/what-is-induce' },
];

export const SOLUTIONS_BREADCRUMB: readonly BreadcrumbItem[] = [
  { label: 'Home', to: '/' },
  { label: 'Solutions', to: '/#solutions' },
];

export const PRICING_BREADCRUMB: readonly BreadcrumbItem[] = [
  { label: 'Home', to: '/' },
  { label: 'Pricing' },
];

export const FAQ_BREADCRUMB: readonly BreadcrumbItem[] = [
  { label: 'Home', to: '/' },
  { label: 'FAQ' },
];

export const SHOWREEL_BREADCRUMB: readonly BreadcrumbItem[] = [
  { label: 'Home', to: '/' },
  { label: 'Showreel' },
];

export const WHAT_IS_INDUCE_BREADCRUMB: readonly BreadcrumbItem[] = [
  { label: 'Home', to: '/' },
  { label: 'About Induce' },
];

export const PRIVACY_BREADCRUMB: readonly BreadcrumbItem[] = [
  { label: 'Home', to: '/' },
  { label: 'Privacy Policy' },
];

export const TERMS_BREADCRUMB: readonly BreadcrumbItem[] = [
  { label: 'Home', to: '/' },
  { label: 'Terms of Service' },
];

export const USE_CASES_BREADCRUMB: readonly BreadcrumbItem[] = [
  { label: 'Home', to: '/' },
  { label: 'Use Cases' },
];

export const BLOG_BREADCRUMB: readonly BreadcrumbItem[] = [
  { label: 'Home', to: '/' },
  { label: 'Blog' },
];
